import moment from 'moment';
import isEqual from 'lodash/isEqual';

export default class JsonApiRecordDecorator {
  unwrap() {
    let attributes = Object.assign({}, this);
    delete attributes.id;
    delete attributes._original;
    return {
      id: this.id,
      type: this.type,
      attributes
    }
  }
  getMeta() {
    return this._original.meta;
  }
  standardizeValue(currVal) {
    const date = moment(currVal);
    switch (true) {
    case (Array.isArray(currVal)):
      return currVal.slice(0).sort();
    case (['object', 'boolean'].includes(typeof currVal)):
      return currVal;
    case (currVal === 'true'):
      return true;
    case (currVal === 'false'):
      return false;
    case (currVal === ''):
      return null;
    case (!isNaN(currVal)):
      return Number(currVal);
    case (date.isValid()):
      return date.toISOString();
    default:
      return currVal;
    }
  }
  get isDirty(){
    if (this._original) {
      return Object.entries(this._original.attributes).some(([ key, origValue ]) => {
        let origVal = this.standardizeValue(origValue);
        let currVal = this.standardizeValue(this[key]);
        return !isEqual(currVal, origVal);
      });
    } else {
      return Object.entries(this).some(([ key, value ]) => {
        //type will always be set, but that doesn't make a new object dirty
        if (key === 'type'){
          return false;
        } else {
          return Array.isArray(value) ? !!value.length : !!value;
        }
      });
    }
  }
}
